.optionIcon {
  margin-bottom: 3px;
  color: var(--color-white);
}
